/* eslint-disable  */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { FaCamera, FaImages, FaTimes, FaIdCard, FaUserCircle } from "react-icons/fa";
import Resizer from "react-image-file-resizer";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./ApplyLoans.css";
import Webcam from "react-webcam";
import Loan_chip from "./components/Loan_chip";

function Uploads() {
  const dispatch = useDispatch();
  const history = useHistory();
  const signatureRef = useRef({});

  const {
    ResetUserDataResponse,
    GetFormOneAppliedLoanTemp,
    UpdateIDCardUpload,
    UpdateLoanTempPassportImageUpload,
    CancelLoanApplicationTemp,
  } = bindActionCreators(userDataActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);
  const [formState, setFormState] = useState(4);
  const [previewFrontCard, setPreviewFrontCard] = useState(null);
  const [previewBackCard, setPreviewBackCard] = useState(null);
  const [previewPassportImage, setPreviewPassportImage] = useState(null);
  const [privacyChecked, setPrivacyChecked] = useState(false);

  const [formData, setFormData] = useState({});
  const [loanAmount, setLoanAmount] = useState(0);
  const [affordability, seAffordability] = useState(0);
  const [loanTerm, setLoanTerm] = useState(null);
  const [monthlyDeduction, setMonthlyDeduction] = useState(0);
  const [age, setAge] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [seletedFiles, setSeletedFiles] = useState([]);

  // Camera state
  const [showCamera, setShowCamera] = useState(false);
  const [cameraTarget, setCameraTarget] = useState(null); // "frontCard" or "passport"
  const webcamRef = useRef(null);
  const frontCardFileRef = useRef(null);
  const passportFileRef = useRef(null);

  const response = useSelector((state) => state?.user?.response);
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const auth = useSelector((state) => state?.auth);
  const user = auth?.user;
  const userData = useSelector((state) => state?.user);

  const { loanTemp } = userData;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const handleIDCardChange = (e) => {
    e.preventDefault();
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      const reader = new FileReader();
      reader.onload = (ev) => {
        try {
          Resizer.imageFileResizer(
            e.target.files[0],
            800,
            500,
            "png",
            100,
            0,
            (uri) => {
              UpdateIDCardUpload(
                uri,
                loanTemp?.frontIDImage_key ? loanTemp?.frontIDImage_key : "",
                loanTemp?._id
              );
            },
            "file"
          );
        } catch (err) {
          console.log(err);
        }
        if (e?.target?.name === "backCard") {
          setPreviewBackCard(ev?.target?.result);
        } else if (e?.target?.name === "frontCard") {
          setPreviewFrontCard(ev?.target?.result);
        }
      };

      setSeletedFiles([...seletedFiles, file]);
      reader.readAsDataURL(file);
    }
  };

  const handlePassportChange = (e) => {
    e.preventDefault();
    if (e?.target?.files[0]) {
      const file = e?.target?.files[0];
      const reader = new FileReader();
      reader.onload = (ev) => {
        setPreviewPassportImage(ev?.target?.result);
        try {
          Resizer.imageFileResizer(
            e.target.files[0],
            800,
            400,
            "png",
            100,
            0,
            (uri) => {
              UpdateLoanTempPassportImageUpload(
                uri,
                loanTemp?.passportImage_key ? loanTemp?.passportImage_key : "",
                loanTemp?._id
              );
            },
            "file"
          );
        } catch (err) {
          console.log(err);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const openCamera = (target) => {
    setCameraTarget(target);
    setShowCamera(true);
  };

  const capturePhoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      const file = dataURLtoFile(imageSrc, "camera-capture.png");

      if (cameraTarget === "frontCard") {
        setPreviewFrontCard(imageSrc);
        try {
          Resizer.imageFileResizer(
            file,
            800,
            500,
            "png",
            100,
            0,
            (uri) => {
              UpdateIDCardUpload(
                uri,
                loanTemp?.frontIDImage_key ? loanTemp?.frontIDImage_key : "",
                loanTemp?._id
              );
            },
            "file"
          );
        } catch (err) {
          console.log(err);
        }
      } else if (cameraTarget === "passport") {
        setPreviewPassportImage(imageSrc);
        try {
          Resizer.imageFileResizer(
            file,
            800,
            400,
            "png",
            100,
            0,
            (uri) => {
              UpdateLoanTempPassportImageUpload(
                uri,
                loanTemp?.passportImage_key ? loanTemp?.passportImage_key : "",
                loanTemp?._id
              );
            },
            "file"
          );
        } catch (err) {
          console.log(err);
        }
      }
      setShowCamera(false);
    }
  }, [webcamRef, cameraTarget, loanTemp]);

  const handleCancelLoanApplication = () => {
    CancelLoanApplicationTemp(loanTemp?._id);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (loanTemp?.passportImage && loanTemp?.frontIDImage) {
      history.push("/apply-loan-preview");
    } else {
      toast.error("Please make sure to upload images for Ghana Card");
    }
  };

  useEffect(() => {
    GetUserProfile();
    GetFormOneAppliedLoanTemp();
    setFormData({
      ...formData,
      backIDImage_key: loanTemp?.backIDImage_key,
      frontIDImage_key: loanTemp?.frontIDImage_key,
      passportImage_key: loanTemp?.passportImage_key,
    });

    setPreviewBackCard(formData?.frontIDImage);
    setPreviewFrontCard(formData?.backIDImage);
    setPreviewPassportImage(formData?.passportImage);
  }, []);

  useEffect(() => {
    GetUserProfile();
    GetFormOneAppliedLoanTemp();
    setFormData({
      ...formData,
      backIDImage_key: loanTemp?.backIDImage_key,
      frontIDImage_key: loanTemp?.frontIDImage_key,
      passportImage_key: loanTemp?.passportImage_key,
    });

    setPreviewBackCard(formData?.frontIDImage);
    setPreviewFrontCard(formData?.backIDImage);
    setPreviewPassportImage(formData?.passportImage);
  }, [loanTerm]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      GetFormOneAppliedLoanTemp();
      setTimeout(() => {
        ResetUserDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetUserDataResponse();
      }, 1500);
    } else if (response?.state === "DELETED") {
      toast.success(response?.message);
      history.push("/apply-loan-1");
      setTimeout(() => {
        ResetUserDataResponse();
      }, 1500);
    } else if (response?.state === "UPLOAD_SUCCESS") {
      toast.success(response?.message);
      GetFormOneAppliedLoanTemp();
      window.location.reload(false);
      setTimeout(() => {
        ResetUserDataResponse();
      }, 1500);
    }
  }, [response?.state, response?.message, response?.action]);

  const frontCardImage =
    previewFrontCard ||
    (loanTemp?.frontIDImage ?? loanTemp?.frontIDImage);
  const passportImage =
    previewPassportImage ||
    (loanTemp?.passportImage ?? loanTemp?.passportImage);

  /* Shared styles */
  const uploadCardStyle = {
    background: "#fff",
    borderRadius: "0.75rem",
    border: "1px solid #e5e7eb",
    padding: "1.25rem",
    marginBottom: "1.25rem",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  };

  const imagePreviewStyle = {
    width: "100%",
    height: "200px",
    borderRadius: "0.5rem",
    border: "2px dashed #d1d5db",
    background: "#f9fafb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    marginBottom: "1rem",
  };

  const btnStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "0.4rem",
    padding: "0.5rem 1rem",
    border: "1px solid #d1d5db",
    borderRadius: "0.5rem",
    background: "#fff",
    cursor: "pointer",
    fontSize: "0.8rem",
    color: "#374151",
    fontWeight: 500,
    transition: "all 0.2s",
  };

  const sectionTitleStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: "1rem",
    fontWeight: 600,
    color: "#1f2937",
    marginBottom: "0.75rem",
  };

  return (
    <div className="ApplyLoans">
      <RenderHome title={"Apply Loan"}>
        {isLoading ?? <Loader />}

        <Loan_chip formState={formState} />

        <form action="">
          {formState === 4 && (
            <div
              style={{
                maxWidth: "700px",
                margin: "0 auto",
                padding: "1.5rem 1rem",
              }}
            >
              {/* Header */}
              <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
                <h3
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: 700,
                    color: "#1f2937",
                    marginBottom: "0.5rem",
                  }}
                >
                  Upload Documents
                </h3>
                <p
                  style={{
                    fontSize: "0.85rem",
                    color: "#6b7280",
                    maxWidth: "480px",
                    margin: "0 auto",
                    lineHeight: 1.5,
                  }}
                >
                  Only Ghana National Identification card is accepted. Other ID
                  cards will be rejected.
                </p>
              </div>

              {/* Ghana Card Front Upload */}
              <div style={uploadCardStyle}>
                <div style={sectionTitleStyle}>
                  <FaIdCard style={{ color: "#6366f1", fontSize: "1.1rem" }} />
                  <span>Ghana Card (Front)</span>
                  {frontCardImage && (
                    <span
                      style={{
                        marginLeft: "auto",
                        fontSize: "0.7rem",
                        color: "#16a34a",
                        background: "#f0fdf4",
                        padding: "0.15rem 0.5rem",
                        borderRadius: "1rem",
                        fontWeight: 500,
                      }}
                    >
                      Uploaded
                    </span>
                  )}
                </div>

                <div style={imagePreviewStyle}>
                  {frontCardImage ? (
                    <img
                      src={frontCardImage}
                      alt="Ghana Card Front"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        borderRadius: "0.5rem",
                      }}
                    />
                  ) : (
                    <div style={{ textAlign: "center", color: "#9ca3af" }}>
                      <FaIdCard style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }} />
                      <p style={{ fontSize: "0.8rem", margin: 0 }}>
                        No image uploaded yet
                      </p>
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "0.75rem",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => frontCardFileRef.current.click()}
                    style={btnStyle}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = "#f3f4f6";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = "#fff";
                    }}
                  >
                    <FaImages style={{ color: "#6366f1" }} />
                    Gallery
                  </button>
                  <button
                    type="button"
                    onClick={() => openCamera("frontCard")}
                    style={btnStyle}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = "#f3f4f6";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = "#fff";
                    }}
                  >
                    <FaCamera style={{ color: "#6366f1" }} />
                    Camera
                  </button>
                </div>

                <input
                  ref={frontCardFileRef}
                  type="file"
                  name="frontCard"
                  accept=".png,.jpg,.jpeg"
                  onChange={(e) => handleIDCardChange(e)}
                  style={{ display: "none" }}
                />
              </div>

              {/* Ghana Card Back Upload */}
              <div style={uploadCardStyle}>
                <div style={sectionTitleStyle}>
                  <FaIdCard style={{ color: "#6366f1", fontSize: "1.1rem" }} />
                  <span>Ghana Card (Back)</span>
                  {passportImage && (
                    <span
                      style={{
                        marginLeft: "auto",
                        fontSize: "0.7rem",
                        color: "#16a34a",
                        background: "#f0fdf4",
                        padding: "0.15rem 0.5rem",
                        borderRadius: "1rem",
                        fontWeight: 500,
                      }}
                    >
                      Uploaded
                    </span>
                  )}
                </div>

                <div style={imagePreviewStyle}>
                  {passportImage ? (
                    <img
                      src={passportImage}
                      alt="Ghana Card Back"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        borderRadius: "0.5rem",
                      }}
                    />
                  ) : (
                    <div style={{ textAlign: "center", color: "#9ca3af" }}>
                      <FaIdCard style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }} />
                      <p style={{ fontSize: "0.8rem", margin: 0 }}>
                        No image uploaded yet
                      </p>
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "0.75rem",
                    justifyContent: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => passportFileRef.current.click()}
                    style={btnStyle}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = "#f3f4f6";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = "#fff";
                    }}
                  >
                    <FaImages style={{ color: "#6366f1" }} />
                    Gallery
                  </button>
                  <button
                    type="button"
                    onClick={() => openCamera("passport")}
                    style={btnStyle}
                    onMouseOver={(e) => {
                      e.currentTarget.style.background = "#f3f4f6";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.background = "#fff";
                    }}
                  >
                    <FaCamera style={{ color: "#6366f1" }} />
                    Camera
                  </button>
                </div>

                <input
                  ref={passportFileRef}
                  type="file"
                  name="passport"
                  accept=".png,.jpg,.jpeg"
                  onChange={(e) => handlePassportChange(e)}
                  style={{ display: "none" }}
                />
              </div>

              {/* Navigation Buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "1.5rem",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <button
                  type="button"
                  className="button_cancel cursor-pointer backBtn"
                  onClick={() => history.push("/apply-loan-loan_detailed")}
                  style={{
                    padding: "0.6rem 1.5rem",
                    borderRadius: "1.5rem",
                    fontWeight: 500,
                    fontSize: "0.9rem",
                    backgroundColor: "#e5e7eb",
                    color: "#374151",
                  }}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="button"
                  onClick={(e) => handleFormSubmit(e)}
                  style={{
                    padding: "0.6rem 1.5rem",
                    borderRadius: "1.5rem",
                    fontWeight: 500,
                    fontSize: "0.9rem",
                    backgroundColor: "#058740",
                    color: "#fff",
                  }}
                >
                  Preview Data
                </button>
              </div>
            </div>
          )}
        </form>

        {/* Webcam Modal */}
        {showCamera && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              padding: "1rem",
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "1rem",
                padding: "1.5rem",
                width: "100%",
                maxWidth: "460px",
                textAlign: "center",
                position: "relative",
              }}
            >
              <button
                type="button"
                onClick={() => setShowCamera(false)}
                style={{
                  position: "absolute",
                  top: "0.75rem",
                  right: "0.75rem",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "1.2rem",
                  color: "#6b7280",
                }}
              >
                <FaTimes />
              </button>

              <h4
                style={{
                  marginBottom: "1rem",
                  fontWeight: 600,
                  color: "#1f2937",
                }}
              >
                {cameraTarget === "frontCard"
                  ? "Take Photo - Ghana Card (Front)"
                  : "Take Photo - Ghana Card (Back)"}
              </h4>

              <div
                style={{
                  borderRadius: "0.75rem",
                  overflow: "hidden",
                  marginBottom: "1rem",
                }}
              >
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/png"
                  videoConstraints={{
                    facingMode: "environment",
                    width: 640,
                    height: 480,
                  }}
                  style={{ width: "100%", borderRadius: "0.75rem" }}
                />
              </div>

              <button
                type="button"
                onClick={capturePhoto}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  padding: "0.65rem 2rem",
                  background: "#6366f1",
                  color: "#fff",
                  border: "none",
                  borderRadius: "0.5rem",
                  cursor: "pointer",
                  fontSize: "0.9rem",
                  fontWeight: 500,
                }}
              >
                <FaCamera />
                Capture
              </button>
            </div>
          </div>
        )}
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default Uploads;
